import { render, staticRenderFns } from "./workerListFif.vue?vue&type=template&id=064899a6&scoped=true"
import script from "./workerListFif.vue?vue&type=script&lang=js"
export * from "./workerListFif.vue?vue&type=script&lang=js"
import style0 from "./workerListFif.vue?vue&type=style&index=0&id=064899a6&prod&scoped=true&lang=less"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "064899a6",
  null
  
)

export default component.exports